import { setCitizenshipProfileFromRequest } from "@/models/Product";
import { getHttpClient } from "@/http-client";

const baseUrl = "api/boss/citizenship_profiles";
export async function getAllCitizenshipProfiles() {
  const { data } = await getHttpClient().get(baseUrl);

  return data.citizenship_profiles.map(setCitizenshipProfileFromRequest);
}
